module.exports = __webpack_public_path__ + "7312880f1695cb95b6196327c651c976.MP3";